import { CommonModule } from '@angular/common'
import type { AfterViewInit, ElementRef, OnInit } from '@angular/core'
import { ChangeDetectionStrategy, Component, inject, viewChild } from '@angular/core'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { Events } from '@ngrx/signals/events'
import { filter, merge } from 'rxjs'

import { Account } from '@account/models'
import { ConversationStore } from '@app/modules/messaging/components/store/conversation.store'
import { sendingEvents } from '@app/modules/messaging/components/store/sending.events'
import { Closeable } from '@app/overlays/closeable'
import { UIModule } from '@ui/ui.module'

import { MESSAGE_PHOTO_ALBUM_CONFIG, MessagePhotoAlbumStore } from './message-photo-album.store'
import { S3MediaUploadDirective } from '../../../../../s3-upload/directives/s3-media-upload.directive'
import { photoUploadEvents } from '../../store/photo-upload.events'

@UntilDestroy()
@Component({
  selector: 'sb-message-photo-album-modal',
  templateUrl: './message-photo-album-modal.component.html',
  styleUrls: ['./message-photo-album-modal.component.scss'],
  providers: [MessagePhotoAlbumStore],
  imports: [CommonModule, UIModule, S3MediaUploadDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagePhotoAlbumModalComponent extends Closeable implements AfterViewInit, OnInit {
  readonly messagePhotoAlbumStore = inject(MessagePhotoAlbumStore)
  readonly conversationStore = inject(ConversationStore)
  private readonly events = inject(Events)
  private readonly account = inject(Account)
  readonly messagePhotoAlbumConfig = inject(MESSAGE_PHOTO_ALBUM_CONFIG)

  private readonly inputElement = viewChild.required<ElementRef<HTMLInputElement>>('attachPhotoInput')

  ngOnInit(): void {
    merge(
      this.events.on(sendingEvents.sendMessageSuccess),
      this.events
        .on(photoUploadEvents.uploadComplete)
        .pipe(filter(event => event.payload.batchUpload.successful.length > 0)),
    )
      .pipe(untilDestroyed(this))
      .subscribe(() => this.close())
  }

  ngAfterViewInit(): void {
    if (!this.account.has_message_album_photo) {
      this.inputElement().nativeElement.click()
    }
  }
}
